<template>
  <div class="container">
    <div class="filter-tab">
      <h3>Categorias y Marcas</h3>
      <div class="list-marcas">
        <ul>
          <li @click="FilterMarca(i)" v-for="(i, index) in 10" :key="index">
            <h4>Marca {{ i }}</h4>
          </li>
        </ul>
      </div>
      <div>
        <h4>Precio</h4>
        <div>
          <p class="titulo-slider">Desde</p>
          <input v-model="rangeSlider[0]" type="text" />
          <p class="titulo-slider">Hasta</p>
          <input v-model="rangeSlider[1]" type="text" />
          <button class="btn btn-secondary">Filtrar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  methods: {},

  data() {
    return {
      range: { min: 0, max: 5000000 },
      rangeSlider: [0, 2500000],
    };
  },
};
</script>
<style lang="scss" scoped>
.filter-tab {
  width: 200px;
  height: 600px;
  padding: 10px;
  border: 0.5px solid #dcdcdc;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-right: 20px;
  .list-marcas {
    height: 200px;
    overflow-y: scroll;
  }
  .titulo-slider {
    margin-bottom: 5px;
    font-weight: 500;
  }
}
</style>
